module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.woff2?f39d4ae163e7d4fab81b9910c1a94900";